module.exports = __webpack_public_path__ + "static/media/happy-gamer.556be6ab.webp";